import {
  REQUEST_DONATION_GROUP_LIST,
  REQUEST_DONATION_GROUP
} from './mutation-types';

export default {
  [REQUEST_DONATION_GROUP_LIST] (state, receivedData) {
    state.donationGroups = receivedData.content;
    state.donationGroupCount = receivedData.totalElements;
  },
  [REQUEST_DONATION_GROUP] (state, receivedData) {
    state.donationGroup = receivedData
  }
}